<div id="fade"></div>
<div id="modal">
    <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
    <label style="color:black;"><strong>{{officeDataService.ModalMsg}}</strong></label>
</div>

<div class="fixed-top">
    <nav class="navbar navbar-inverse" style="background-color: white;">
        <button class="navbar-toggler btn btn-lg btn-icon-only btn-text-dark" id="menuButton" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false">
            <i class="modus-icons notranslate">menu</i>
        </button>

        <div style=" display: contents;">
            <a class="navbar-brand mr-auto" href="/">
                <img id="logo" style="display: inline;" [src]="logoUrl" alt="" *ngIf="image != null && showImageNow" />
                <img id="logo" style="display: inline;max-width:276px;" src="/Cache/images/viewpoint-logo2.png" alt="" *ngIf="image == null && showImageNow" />
                <span class="navbar-brand-text" *ngIf="showImageNow" style="font-size: 15px;margin-top: 5px; margin-left: 10px;">
                    {{portalName}}
                </span>
            </a>
        </div>

        <select class="form-control" [(ngModel)]="formData.selectedCompany" (change)="companyChange()" style="float: right; width: 300px; ">
            <option *ngFor="let data of companyList" [ngValue]="data.HQCo">{{data.Name}}</option>
        </select>
    </nav>
    <div class="collapse" id="navbarMenu">
        <div class="p-4" style="background-color: #f1f1f6; ">
            <div class="row" style="width: 100%;">
                <div class="col-md-3 col-sm-12 col-xs-12" style="overflow-x: hidden;margin-bottom:15px;" [ngClass]="{'height500' : !shortMenu, 'height300' : shortMenu}">
                    <ul class="nav flex-column nav-pills" id="formList" role="tablist" aria-orientation="vertical">
                        <li class="nav-item" *ngFor="let groupedForm of groupedFormList; let i = index">
                            <a class="nav-link" data-toggle="pill" role="tab" aria-controls="{{groupedForm.groupDisplay}}" aria-selected="false" (click)="groupSelected(groupedForm)" style="cursor: pointer;">{{groupedForm.groupDisplay}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-md-9 col-sm-12 col-xs-12" style="overflow-x: hidden;" [ngClass]="{'height500' : !shortMenu, 'height300' : shortMenu}">
                    <div class="row">
                        <button class="btn btn-primary" (click)="routeToReportGateway()" *ngIf="selectedFormList.length > 0" style="margin-left: 15px;">View Reports</button>
                    </div>
                    <div class="row" style="margin-left:0px;display: block;">
                        <ul class="list-group col-md-6 col-sm-12 col-xs-12" *ngFor="let subGroup of selectedFormList; let i = index" style="margin-top:10px;display:block;" [ngClass]="{'floatLeftOdd' : i % 2 == 0, 'floatRightEven' : i % 2 == 1}">
                            <div *ngIf="subGroup[0].FormGroup != null">
                                <h6>{{subGroup[0].FormGroup}}</h6>
                                <li class="list-group-item" *ngFor="let item of subGroup; let i = index" (click)="itemSelected(item)" style="cursor:pointer">{{item.FormDesc}}</li>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--<nav id="NavBar" class="navbar nav navbar-expand-custom navbar-inverse fixed-top" role="navigation" style="padding-left:0;">-->
<!--<button class="btn btn-lg btn-icon-only btn-text-dark" data-toggle="dropdown" type="button">
    <i class="modus-icons notranslate">menu</i>
</button>
<div class="dropdown-menu nav-dropdown-menu" style="left: 10px;">
    <ul class="nav nav-tabs" role="tablist" style="display:inline;">
        <li class="nav-item">
        </li>
        <li class="nav-item">
            <a class="nav-link" id="exampleSecondTab" data-toggle="tab" href="#exampleSecond" role="tab" aria-controls="exampleSecond" aria-selected="false">Second tab</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" id="exampleThirdTab" data-toggle="tab" href="#exampleThird" role="tab" aria-controls="exampleThird" aria-selected="false">Third tab</a>
        </li>
        <li class="nav-item">
            <a class="nav-link disabled" id="disabledTab" data-toggle="tab" href="#exampleDisabled" role="tab" aria-controls="exampleDisabled" aria-selected="false">Disabled tab</a>
        </li>
    </ul>
</div>-->
<!--<div class="container-fluid" style="flex-wrap: nowrap; padding-left:0; padding-right:0;">
    <a class="navbar-brand mr-auto" href="/" style="display: inline-flex">
        <img id="logo" style="display: inline;" [src]="logoUrl" alt="" *ngIf="image != null && showImageNow" />
        <img id="logo" style="display: inline;max-width:276px;" src="/Cache/images/viewpoint-logo2.png" alt="" *ngIf="image == null && showImageNow" />
        <span class="navbar-brand-text" *ngIf="showImageNow" style="font-size: 15px;margin-top: 5px; margin-left: 10px;">
            {{portalName
                            }}
                            </span>
                        </a>
</div>-->
<!--<div class="collapse navbar-collapse">
    <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown" style="max-height: 50px; ">
            <a class="nav-link" href="#" data-toggle="dropdown">
                <span class="oi oi-grid-three-up"></span>
            </a>
            <div class="dropdown-menu nav-dropdown-menu" style="left: auto; right: 0">
                <ul class="col-md-12">
                    <div class="multi-column-dropdown">
                        <li>
                            <a class="dropdown-item" [href]="" style="font-size: 13px">Navigate to TC1 Homepage</a>
                        </li>
                        <li>
                            <a class="dropdown-item" [href]="" style="font-size: 13px">Viewpoint Analytics</a>
                        </li>
                    </div>
                </ul>
            </div>
        </li>
    </ul>
</div>-->
<!--<select class="form-control" [(ngModel)]="formData.selectedCompany" (change)="companyChange()">
        <option *ngFor="let data of companyList" [ngValue]="data.HQCo">{{data.Name}}</option>
    </select>
</nav>-->
